import { render, staticRenderFns } from "./ApplicantOtherIncomes.vue?vue&type=template&id=1a6b5671&scoped=true&"
import script from "./ApplicantOtherIncomes.vue?vue&type=script&lang=js&"
export * from "./ApplicantOtherIncomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b5671",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VForm,VIcon,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6b5671')) {
      api.createRecord('1a6b5671', component.options)
    } else {
      api.reload('1a6b5671', component.options)
    }
    module.hot.accept("./ApplicantOtherIncomes.vue?vue&type=template&id=1a6b5671&scoped=true&", function () {
      api.rerender('1a6b5671', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Apply/ApplicantOtherIncomes.vue"
export default component.exports